import { motion } from "motion/react"
import { useRef } from "react"

function SubwayLine({ draw, stroke, strokeWidth, d, ref, onStationTrigger, stations = [], viewBox = "0 0 1000 2114" }) {
    // Track which stations have already been triggered
    const triggeredStations = useRef(new Set());
    const pathRef = useRef(null);
    const svgRef = useRef(null);

    const handleUpdate = (latest) => {
        // latest contains the current animation values
        const progress = latest.pathLength;
  
        // Get the actual SVG path element to calculate positions
        const pathEl = pathRef.current;
        const svgEl = svgRef.current;
        
        if (!pathEl || !svgEl) return;

            for (const [index, station] of stations.entries()) {
                // Distribute stations between 10% and 90% of the path
                // This skips the top 10% and bottom 10%
                const stationRange = 0.8; // 90% - 10% = 80%
                const stationOffset = 0.1; // Start at 10%
                const stationProgress = stationOffset + ((index + 1) / (stations.length + 1)) * stationRange;
                const tolerance = 0.02; // 2% tolerance
         
                // Check if we've reached this station's position and haven't triggered it yet
                if (progress >= stationProgress - tolerance && 
                    progress <= stationProgress + tolerance && 
                    !triggeredStations.current.has(station.id)) {

                  
                  // Mark station as triggered
               
                  
                  // Use SVG methods to get exact coordinates
                  const totalLength = pathEl.getTotalLength();
                  const distanceAlongPath = totalLength * stationProgress;
                  const point = pathEl.getPointAtLength(distanceAlongPath);
                  
                  // Convert SVG coordinates to screen coordinates
                  const svgPoint = svgEl.createSVGPoint();
                  svgPoint.x = point.x;
                  svgPoint.y = point.y;
                  const matrix = svgEl.getScreenCTM();
                  const screenPoint = matrix ? svgPoint.matrixTransform(matrix) : point;
                  
     
                    triggeredStations.current.add(station.id);
                 
                  
                  console.log(`Triggering station ${station.id} at progress ${progress}, SVG point:`, point, 'Screen point:', screenPoint);
                  
                  // Trigger station appearance
                  if (onStationTrigger) {
                    onStationTrigger({
                      station,
                      index,
                      x: screenPoint.x <  0 ? 0 : screenPoint.x,
                      y: screenPoint.y,
                      svgX: point.x < 0 ? 0 : point.x,
                      svgY: point.y,
                      progress: stationProgress
                    });
                  }
               // }
            } 
            }

      
      };
    
    
return (
<motion.svg
ref={(el) => {
  svgRef.current = el;
  if (ref) {
    if (typeof ref === 'function') ref(el);
    else ref.current = el;
  }
}}
width="100%"
height="100%"
viewBox={viewBox}
fill="none" 
initial="hidden"
animate="visible"
style={{
position: 'absolute',
zIndex: 10,
overflow: 'visible'
}}
>
<motion.path
ref={pathRef}
d={d}
stroke={stroke}
strokeWidth={strokeWidth}
initial={{ pathLength: 0 }}
animate={{ pathLength: 100, duration: 1000 }}
onUpdate={handleUpdate}
variants={draw}
/>
</motion.svg>
)
}

export default SubwayLine;